import React from 'react';
import QuizSubjectTopics from '../../topics/QuizSubjectTopics';

function QuizGKTopics() {
  return (
   <>
   
   <QuizSubjectTopics name="quiz" link="quiz/gk" type="quiz" subject="gk" topic="atoz" subjectName="gk" />

   </>
  );
}

export default QuizGKTopics;